import { useUserStore } from '@caradasstore/UserStore'

import { isClientUser } from '../utils/utils'

/**
 * True when the signed-in user may look but not touch.
 *
 * One hook rather than an `is_client_user` check scattered through the screens: the
 * existing role derivations were each written by hand, which is exactly why adding a
 * role to this app is risky. Anything that creates, edits, deletes, sends or uploads
 * should hide or disable itself when this is true - except booking an appointment, the
 * one write the client role may make (FormModal's `clientMayEdit`, the New Appointment
 * buttons, and the request guard's booking exemptions).
 *
 * Hiding a control is a courtesy, not the security boundary - the API refuses the write
 * regardless (ReadOnlyAccessFilter). currentUser is loaded by PageLayout, so this is
 * false until the role is actually known; guard destructive UI on the server's answer,
 * never on this alone.
 */
export const useIsReadOnly = () => {
  const currentUser = useUserStore((store) => store.currentUser)

  return isClientUser(currentUser)
}
